/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconLightningTrio: {
  name: 'lightning_trio';
  data: string;
} = {
  name: 'lightning_trio',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m64.847 74.654 300.81 400.789-5.829-71.444 200.304 158.652-220.786-333.394 5.829 71.444L64.847 74.654zM92.777 58.261l320.239 140.093-20.563-43.959L554.08 170.97 337.747 49.335l20.563 43.958L92.777 58.261zM43.596 109.668l39.526 342.643 27.747-44.242 73.75 150.901-10.403-261.142-27.747 44.242L43.596 109.668z"/></svg>`,
};
